"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const semver_1 = require("semver");
let IsSemVer = class IsSemVer {
    validate(text) {
        return !!semver_1.valid(text);
    }
    defaultMessage() {
        return '$value is not a valid semantic version. See https://semver.org/ for more information.';
    }
};
IsSemVer = tslib_1.__decorate([
    class_validator_1.ValidatorConstraint({
        async: false,
        name: 'customText',
    })
], IsSemVer);
exports.IsSemVer = IsSemVer;
//# sourceMappingURL=IsSemVer.js.map